<template>
    <div>
        <b-modal
            id="modalFinalizacaoAnexoForm"
            v-model="mostrarModalFinalizacaoAnexoForm"
            @show="preencherForm()"
        >
            <div slot="modal-title">
                Finalização - Anexo -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Tipo do Anexo</label>
                        <b-form-select
                            :plain="true"
                            :options="tiposAnexosSelect"
                            v-model="tipoId"
                            text-field="descricao"
                            value-field="anexoTipoId"
                        ></b-form-select>
                    </b-form-group>
                    <b-alert show v-if="tipo && tipo.ajuda">{{
                        tipo.ajuda
                    }}</b-alert>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Descritivo</label>
                        <b-form-input
                            type="text"
                            placeholder="Descritivo"
                            v-model="descritivo"
                            @input="$v.descritivo.$touch()"
                            :state="$v.descritivo.$error ? false : null"
                        ></b-form-input>
                        <b-form-invalid-feedback
                            >O descritivo do anexo é
                            obrigatório</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Arquivo</label>
                        <b-form-file
                            v-model="arquivo"
                            :state="Boolean(arquivo)"
                            placeholder="Selecione o arquivo..."
                            ref="arquivoInput"
                            browse-text="Selecionar"
                        ></b-form-file>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharFinalizacaoAnexoForm()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="salvarFinalizacaoAnexo()"
                    class="ml-2"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'finalizacao-anexo-form',

    props: {
        finalizacao: {
            type: Object,
            default: () => ({})
        },

        finalizacoesServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModalFinalizacaoAnexoForm: false,
            operacao: 'INSERIR',
            erros: [],
            obterFinalizacaoAtualizada: false,
            tiposAnexosSelect: [],
            tipoId: '',
            descritivo: '',
            arquivo: null
        }
    },

    methods: {
        fecharFinalizacaoAnexoForm() {
            this.mostrarModalFinalizacaoAnexoForm = false
            this.resetFinalizacaoAnexoForm()
            if (this.obterFinalizacaoAtualizada) {
                this.$emit('obterFinalizacaoAtualizada')
            }
        },

        resetFinalizacaoAnexoForm() {
            this.descritivo = ''
            this.tipoId = ''
            this.erros = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {
            this.obterFinalizacaoAtualizada = false
        },

        salvarFinalizacaoAnexo() {
            this.mostrarModalFinalizacaoAnexoForm = false
            this.$store.dispatch('addRequest')
            let finalizacaoAnexoData = {
                finalizacaoId: this.finalizacao.finalizacaoId,
                tipoId: this.tipoId,
                descritivo: this.descritivo,
                arquivo: this.arquivo
            }
            this.finalizacoesServicos
                .inserirFinalizacaoAnexo(finalizacaoAnexoData)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.obterFinalizacaoAtualizada = true
                            this.resetFinalizacaoAnexoForm()
                            this.fecharFinalizacaoAnexoForm()
                        } else {
                            this.erros = response.errors
                            this.mostrarModalFinalizacaoAnexoForm = true
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        obterAnexosTipos() {
            this.$store.dispatch('addRequest')
            this.finalizacoesServicos.obterAnexosTipos().then((response) => {
                if (response) {
                    if (response.success) {
                        this.tiposAnexosSelect = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter tipos de anexos!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {
        if (
            this.$temAcesso('CRED-FORN-FIN-03') ||
            this.$temAcesso('CRED-FIN-ANX-01')
        ) {
            this.obterAnexosTipos()
        }
    },

    computed: {
        tipo() {
            let tiposTemp = this.tiposAnexosSelect.find(
                (p) => p.anexoTipoId == this.tipoId
            )
            return tiposTemp ? tiposTemp : {}
        }
    },

    validations: {
        tipoId: {
            required
        },
        arquivo: {
            required
        },
        descritivo: {
            required
        }
    }
}
</script>
